import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({
})
export default class ContactModal extends Vue {
    //
    // ────────────────────────────────────────────────── I ──────────
    //   :::::: P R O P S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────
    //

    @Prop({ type: Boolean }) show!: boolean;
    @Prop({ type: Object }) item!: any;
    @Prop({ type: String }) phoneNumber!: string;

    call(phoneNumber: string) {
        let Param: any = {};
        Param.Type = 'Call';
        Param.PhoneNumber = phoneNumber;
        this.invokeCSCode(JSON.stringify(Param));
    }

    async invokeCSCode(data: any) {
        try {
            if ((window as any).invokeCSharpAction) {
                (window as any).invokeCSharpAction(data);
            } else {
                var obj = JSON.parse(data);
                const link = document.createElement('a');
                link.href = 'tel:' + obj.PhoneNumber;
                link.click();
                (process as any).nextTick(() => link.remove());
            }
        } catch (err) {
            await(window as any).alertAsync(err);
        }
    }
}
